/* eslint-disable @typescript-eslint/no-use-before-define */
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from '../reducers';

import { createHashHistory } from 'history';

export const history = createHashHistory();

const middleware = [thunk, routerMiddleware(history)];

export const generateStore = initialState =>
  createStore(
    createRootReducer(history),
    initialState,
    composeWithDevTools(applyMiddleware(...middleware)),
  );

let store;

export default function getStore() {
  if (!store) {
    store = generateStore({});
  }
  return store;
}
